import React, { useEffect, useState } from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { reelApi } from '../utils/api';
import ReelCard from '../components/reels/ReelCard';
import PageLoader from '../components/common/PageLoader';

function ReelsPage() {
  const navigate = useNavigate();
  const [reels, setReels] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const res = await reelApi.getAll();
        if (!mounted) return;
        setReels(res.data || []);
      } catch (e) {
        console.error('Error loading reels:', e);
      } finally {
        if (mounted) setLoading(false);
      }
    })();
    return () => {
      mounted = false;
    };
  }, []);

  return (
    <main className="page max-w-[1240px] mx-auto px-5 pt-7 pb-[60px] w-full">
      <div className="flex items-center justify-between gap-3 flex-wrap mb-6">
        <h1 className="font-display text-[26px] font-bold">सबै रिल्स</h1>
        <button
          className="inline-flex items-center gap-1.5 px-4 py-2 rounded-full border border-line text-[13px] font-semibold text-ink-soft hover:bg-paper-soft"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft size={14} /> फर्किनुहोस्
        </button>
      </div>

      {loading && <PageLoader />}

      {!loading && reels.length === 0 && (
        <p className="text-muted py-10 text-center">अहिलेसम्म कुनै रिल्स छैन।</p>
      )}

      {!loading && reels.length > 0 && (
        <div className="grid gap-4 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5">
          {reels.map((r) => (
            <div key={r.id} className="w-full">
              <div className="[&>.reel-card]:flex-none [&>.reel-card]:w-full">
                <ReelCard reel={r} />
              </div>
            </div>
          ))}
        </div>
      )}
    </main>
  );
}

export default ReelsPage;
